// removed by extract-text-webpack-plugin
module.exports = {"uploadHint":"_290VrE5vI31NFyKh9AeILs","cloudButtons":"_2VLGlCt9FETJm4pti_io-V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendUploadArea.scss
// module id = 1308
// module chunks = 1